
<app-modal class="modal-overlay" *ngIf="showModal">
  <div class="modal-container">
    <!-- Header do Modal -->
    <div class="modal-header">
      <div class="titulo-modal">
        <h2> Registrar entrada e saída da escola </h2>
      </div>
      <button class="btn-fechar-modal" (click)="closeModal()">✖</button>
    </div>


    @if(userLogado?.autorizacaoUsoDados == 1){
        <button
        class="btn_segundario" (click)="getLocation()">
        Localização
      </button>

      <div>
        {{latitude}} - {{longitude}} - {{device}}
      </div>
    }

  <br />

    <!-- Corpo do Modal -->
    <div class="modal-body">
      <p class="descricao-modal"> Para garantir o registro correto de sua entrada na escola, precisamos de algumas informações importantes. </p>
      <div class="row-escola">
        <img src="../../../assets/img/icons/icon-nome-escola.svg" title="URE" alt="">
        <p>
          <b>URE:</b> {{ this.escola?.nomeDiretoria }}
        </p>
      </div>
      <div class="row-escola" *ngIf="this.escola?.codigoEscola != 0">
        <img src="../../../assets/img/icons/icon-nome-escola.svg" title="Escala" alt="">
        <p>
          <b>Escola </b> {{ this.escola?.codigoEscola }} -  {{ this.escola?.nomeEscola }}
        </p>
        <button class="btn-fechar-modal" (click)="tirarEscola()"><p>✖</p></button>
      </div>


      @if(userLogado?.autorizacaoUsoDados != 1){
        <div class="validacao-autorizacao">
          <p>
            ⚠️ <b>Atenção:</b> é necessário autorizar o uso dos seus dados para continuar.
            <a href="/termos-de-uso-de-dados" target="_blank" rel="noopener noreferrer">Autorizar Dados</a>
          </p>
        </div>
      }

      @if(validaConexaoUsuario){
        <div class="validacao-autorizacao">
          <p>
            <b>
              ⚠️ Detectamos que você não permitiu o acesso a sua localização. Motivo da ausência de localização:
            </b>
          </p>
          <div class="motivo-ausencia">
            <select id="motivo" [(ngModel)]="motivoSelecionado">
              <option value="" disabled selected>Selecione um motivo de ausência de conexão</option>
              <option value="Navegador não suporta">Navegador não suporta</option>
              <option value="Não notei">Não notei</option>
              <option value="Outros">Outros</option>
            </select>

            <input *ngIf="motivoSelecionado === 'Outros'"
              type="text"
              [(ngModel)]="motivoOutro"
              placeholder="Digite o motivo">
          </div>
        </div>
      }

      @if(deslocamento && deslocamento.totalKm > 1000){
        <div class="conteudo-textarea">
          <label for="text-registro">Atenção! Você está a mais de 1km da escola, descreva o motivo.</label>
          <textarea
            id="text-registro"
            name="text-registro"
            rows="6"
            cols="50"
            [(ngModel)]="justificativaDistancia"
            [disabled]="disabledJustificativaDistancia"
            name="dsChamado"
            [minlength]="50"
            [maxLength]="500"
            (keyup)="OnChangeCountLetters()"
            [ngClass]="{ 'is-invalid': submmited && !justificativaDistancia }"

            aria-describedby="descricao-error"
          ></textarea>
          <p class="legenda-textarea">Quantidade de caracteres atual: {{qtdeCaracteresJustificativaDistancia}}</p>
        </div>
      }
    </div>

    <!-- Footer do Modal -->
    <div class="modal-footer">

      @if((infoRegistroPontoSucesso || JornadaAtiva) && !this.otroDia && !showModalJornadaEmAberto)
      {
        <!-- && !this.otroDia -->
        <div class="registro_ponto_sucesso" >
          <!-- <h2>Horário Registro de Entrada: 09:30</h2> -->
          <h2>Jornada iniciada as:{{JornadaAtiva?.dataInicio | date: 'HH:mm'}}</h2>
          <button class="btn_primeiro" (click)="closeModal()">
            OK
          </button>
        </div>
      }


      @if(((!infoRegistroPontoSucesso && !JornadaAtiva) || this.otroDia) && !showModalJornadaEmAberto)
      {
        <!-- || this.otroDia -->
        <button class="btn_segundario" (click)="onClickRegistrarEntrada()" [disabled]="submmited || showModalJornadaEmAberto">
          Registrar Entrada na Escola
        </button>

      }
    </div>
  </div>
</app-modal>

<!-- Modal: Jornada em aberto -->
<app-modal class="modal-overlay" *ngIf="showModalJornadaEmAberto">
  <div class="modal-container">
    <div class="modal-header">
      <div class="titulo-modal">
        <h2>Jornada em aberto</h2>
      </div>
      <button class="btn-fechar-modal" (click)="fecharModalJornadaEmAberto()">✖</button>
    </div>

    <div class="modal-body">
      <p class="descricao-modal">
        Existe uma jornada anterior sem registro de checkout. Para prosseguir, informe o horário de encerramento da jornada pendente.
      </p>

      @if (jornadaEmAbertoParaFechar; as j) {
        <dl class="jornada-em-aberto-resumo">
          <div class="jornada-em-aberto-resumo__linha">
            <dt>Data do check-in</dt>
            <dd>{{ jornadaAbertoResumo.dataCheckIn(j) }}</dd>
          </div>
          <div class="jornada-em-aberto-resumo__linha">
            <dt>Hora do check-in</dt>
            <dd>{{ jornadaAbertoResumo.horaCheckIn(j) }}</dd>
          </div>
          <div class="jornada-em-aberto-resumo__linha">
            <dt>Código da jornada</dt>
            <dd>{{ j.codigoJornada }}</dd>
          </div>
          <div class="jornada-em-aberto-resumo__linha">
            <dt>URE</dt>
            <dd>{{ jornadaAbertoResumo.ure(j) }}</dd>
          </div>
          @if (jornadaAbertoResumo.escola(j); as textoEscola) {
            <div class="jornada-em-aberto-resumo__linha">
              <dt>Escola</dt>
              <dd>{{ textoEscola }}</dd>
            </div>
          }
        </dl>
      }

      <div class="conteudo-select">
        <label for="horaEncerramentoJornadaEmAberto">Horário de encerramento (HH:mm)</label>
        <input
          type="time"
          id="horaEncerramentoJornadaEmAberto"
          name="horaEncerramentoJornadaEmAberto"
          class="input-time"
          [(ngModel)]="horaEncerramentoJornadaEmAberto"
        />

        @if(submittedHoraEncerramentoJornadaEmAberto && !horaEncerramentoJornadaEmAberto){
          <div class="alert">Horário de encerramento é obrigatório.</div>
        }
        @if(erroHoraEncerramentoJornadaEmAberto){
          <div class="alert">{{ erroHoraEncerramentoJornadaEmAberto }}</div>
        }
      </div>
    </div>

    <div class="modal-footer modal-footer-jornada-em-aberto">
      <button class="btn_outline" (click)="fecharModalJornadaEmAberto()">Cancelar</button>
      <button class="btn_primeiro" (click)="confirmarEncerramentoJornadaEmAberto()">Confirmar</button>
    </div>
  </div>
</app-modal>

<app-modal *ngIf="showModalDeslocamento">
  <div class="container-conviva form-registro modal-envolvidos modal-visita-psicologo">
    <div class="header-modal-filtro">
      <h1 class="titulo-page">Deseja fazer um deslocamento ?</h1>
      <a class="btn-fechar-modal" (click)="FecharModal()">fechar</a>
    </div>

    <div class="time-line conteudo-registro modal-conteudo-busca-aluno">
      <div class="container-btns">
        <input type="button" (click)="AbrirModalJornada()" class="btn_outline" value="Não" />
        <input type="submit" class="btn_primary" (click)="redirectToDeslocamento()" value="Sim" />
        <input type="button" (click)="FecharModal()" class="btn_terciario" value="Fechar" />
      </div>
    </div>
  </div>
</app-modal>
